export const header = 'Λίστα Χειρουργείων';
